export const OS_TYPES = {
    WINDOWS: 'windows',
    MACOS: 'macos',
    LINUX: 'linux',
    ANDROID: 'android',
    IOS: 'ios',
    IPADOS: 'ipados',
    UNKNOWN: 'unknown',
} as const;

export const OS_MAP: { [key: string]: RegExp } = {
    [OS_TYPES.WINDOWS]: /Windows NT/,
    [OS_TYPES.MACOS]: /Mac OS X/,
    [OS_TYPES.LINUX]: /Linux/,
    [OS_TYPES.ANDROID]: /Android/,
    [OS_TYPES.IOS]: /iPhone|iPod/,
    [OS_TYPES.IPADOS]: /iPad/,
};

export const BROWSER_TYPES = {
    FIREFOX: 'firefox',
    EDGE: 'edge',
    CHROME: 'chrome',
    SAFARI: 'safari',
    OPERA: 'opera',
    UNKNOWN: 'unknown',
} as const;

export const BROWSER_CHECKS: { [key: string]: () => boolean } = {
    [BROWSER_TYPES.FIREFOX]: () => navigator.userAgent.includes('Firefox'),
    [BROWSER_TYPES.EDGE]: () => navigator.userAgent.includes('Edg'),
    [BROWSER_TYPES.CHROME]: () => navigator.userAgent.includes('Chrome') && !navigator.userAgent.includes('Edg'),
    [BROWSER_TYPES.SAFARI]: () => navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome'),
    [BROWSER_TYPES.OPERA]: () => navigator.userAgent.includes('Opera') || navigator.userAgent.includes('OPR'),
};

export const APP_MODES = {
    STANDALONE: 'standalone',
    BROWSER: 'browser',
} as const;
